document.addEventListener('DOMContentLoaded', function () {
  // Get all radio buttons in the form
  const radioButtons = document.querySelectorAll('input[name="buy-quantity-custom"]');
  // Apply Mutation Observer if selling plan picker is present

  if(radioButtons.length){
    const sellingPlanPicker = radioButtons[0].closest(".product").querySelector("[skio-plan-picker][skio-auto-init]");
    if(sellingPlanPicker){
      new MutationObserver(function(mutationsList, observer) {
         if(mutationsList.length){
           const selectedValue = radioButtons[0].closest(".js_quantity_buy__discount-wrapper").querySelector('input[name="buy-quantity-custom"]:checked').value
           updatePrice({ currentTarget: radioButtons[0] }, selectedValue);
         }
      }).observe(sellingPlanPicker, {
         attributeFilter: ['selected', 'value'],
         subtree: true,
      });
    }
  }

  // Add click event listener to each radio button
  radioButtons.forEach(function (radio) {
    radio.addEventListener('click', function (event) {
      //alert("click");
      // Get the value of the selected radio button
      const selectedValue = event.currentTarget.closest(".js_quantity_buy__discount-wrapper").querySelector('input[name="buy-quantity-custom"]:checked').value;

      // Display the selected value
      document.querySelector(".custom_main_product .pdp-card--actions .product-form .price-per-item__container quantity-input input").value = selectedValue;
      //document.getElementById('selectedValue').textContent = 'Selected Value: ' + selectedValue;

      updatePrice(event, selectedValue);

    });
  });

  function updatePrice(event, selectedValue) {
    const totalSelectedVariants = +selectedValue;
    const variantDataScript = event.currentTarget.closest(".js_quantity_buy__discount-wrapper").querySelector('script#price-variant');
    if(!variantDataScript){
      throw ("No Variant Script JSON found!");
    }
    const variantData = JSON.parse(variantDataScript.innerText); 
    

    let percentageObject = { label: "Buy 1", value: 1 };
    if (totalSelectedVariants < 1 || totalSelectedVariants === 1) {
      percentageObject = { label: "Buy 1", value: 1 };
    } else if (totalSelectedVariants > 1 && totalSelectedVariants <= 2) {
      percentageObject = { label: "Buy 2", value: 10 };
    } else if (totalSelectedVariants >= 3) {
      percentageObject = { label: "Buy 3", value: 20 };
    } else {
      percentageObject = { label: "Buy 1", value: 1 };
    }

    // console.log("PercentageObject", percentageObject);
    const { value: packSavings } = percentageObject;

    console.log(packSavings)

    const { price: variantPrice, compare_at_price: compareAtPrice, selling_plan_allocations } = variantData[0]; 
    const currentVariantPriceElement = document.querySelector(".js_product__price");
    const currentCompareAtPriceElement = document.querySelector(".js_product__compare_at_price");

    const productWrapper = document.querySelector(".product__info-container");
    const totalVariantPrice = variantPrice * totalSelectedVariants;
    const totalCompareAtPrice = compareAtPrice * totalSelectedVariants + (window.Zipify?.OCU?.api?._widgetWasTotal ?? 0);

    const newVariantTotalPrice = totalSelectedVariants > 1 ? totalVariantPrice - ((totalVariantPrice / 100) * packSavings) : totalVariantPrice;
    const widgetTotalPrice = newVariantTotalPrice + (window.Zipify?.OCU?.api._widgetTotal ?? 0);
    
    productWrapper.querySelectorAll(".price-item.price-item_first, .price-item--regular, [skio-onetime-price]").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(newVariantTotalPrice, window.Shopify.money_format)));
    productWrapper.querySelectorAll(".price-item.price-item_first, .price-item--regular").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(widgetTotalPrice, window.Shopify.money_format)));
    productWrapper.querySelectorAll(".price-item--compare_at_price").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(totalCompareAtPrice, window.Shopify.money_format)));

    let saveAmount = totalCompareAtPrice - widgetTotalPrice;
    const saleTagElements = productWrapper.querySelectorAll(".price-item__sale");
    saleTagElements.forEach((saleTagElement) => {
      saleTagElement.innerHTML = `Save ${window.Shopify.formatMoney(saveAmount, window.Shopify.money_format)}`;
    });

    if (selling_plan_allocations.length > 1) {
      let totalPercentageOff = totalSelectedVariants > 1 ? 15 + packSavings : 15;
      const subscriptionPrice = totalVariantPrice - ((totalVariantPrice / 100) * totalPercentageOff);
      const widgetPrice = subscriptionPrice + (window.Zipify?.OCU?.api._widgetTotal ?? 0);
      
      productWrapper.querySelectorAll("[skio-subscription-price]").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(subscriptionPrice, window.Shopify.money_format)));
      if (!document.querySelector(".skio-group-input:checked").hasAttribute("skio-one-time")) {
        let subscriptionSaveAmount = totalCompareAtPrice - widgetPrice;
        productWrapper.querySelectorAll(".price-item.price-item_first").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(widgetPrice, window.Shopify.money_format)));
        productWrapper.querySelectorAll(".price-item--compare_at_price").forEach((el) => (el.innerHTML = window.Shopify.formatMoney(totalCompareAtPrice, window.Shopify.money_format)));
        saleTagElements.forEach((saleTagElement) => (saleTagElement.innerHTML = `Save ${window.Shopify.formatMoney(subscriptionSaveAmount, window.Shopify.money_format)}`));
      }
    }
  }
  if (window.Zipify?.OCU?.api) Zipify.OCU.api._updatePriceCustom = updatePrice;

});

/*
  - Update SellingPlan Data on Product Page
  Dev Comments: 
    Moved this script to 'selling-plan-pdp.js' as we don't want it to run for unscented products
    Unscented products have this tag 'ee-scented-product', this can use to do custom edits 
*/


document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('page-loaded');
});

const swipslide1 = document.querySelector('.logo_list_slider');
if (swipslide1){
  let SwiperTop = new Swiper('.logo_list_slider', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 4000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });
}

//Cart Product slider
// var swiper = new Swiper('.cart-upsell-slider', {
//   slidesPerView: 'auto',
//   centeredSlides: false,
//   paginationClickable: true,
//   loop: false,
//   slideToClickedSlide: true,
//   breakpoints: {
//     // when window width is >= 320px
//     749: {
//       loop: false,
//       slidesPerView: 'auto',
//       centeredSlides: false,
//     }
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function handleResize() { 
//       new Swiper(".logo_list_slider", {
//         loop: true,
//         slidesPerView: "auto",
//         spaceBetween: 0,
//         autoplay: 
//         {
//           delay: 0,
//           disableOnInteraction: false,
//         },
//         freeMode: true,
//         speed: 3000,
//         freeModeMomentum: false
//       });
//   }

//   handleResize();
//   window.addEventListener("resize", handleResize);
// });

const swipslide2 = document.querySelector('.follow_derm_dude_slider');
if (swipslide2){
var swiper = new Swiper('.follow_derm_dude_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: true,
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});
}

const swipslide3 = document.querySelector('.image_with_text_slider');
if (swipslide3){
var swiper = new Swiper('.image_with_text_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: true,
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});
}



const all_image_caption_inner = document.querySelectorAll('.image_caption_inner');
all_image_caption_inner.forEach(image_caption => {
  if (image_caption) {
    const plus_icons = image_caption.querySelector('.product-ingredient-plus-wrap');
    const ingredient_content = image_caption.querySelector('.product-ingredient-content-overlay')
    plus_icons.addEventListener('click', () => {


      ingredient_content.style.cssText = "display: block; opacity: 1";
    })

    const close_button = image_caption.querySelector('.product-ingredient-close-box');
    close_button.addEventListener('click', () => {
      ingredient_content.style.cssText = "display: none; opacity: 0";
    })
  }
});

// Tabbing js 

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tab-target').forEach(function (tabLink) {
    tabLink.addEventListener('click', function () {
      document.querySelectorAll('.image-column-tab').forEach(tab => tab.classList.remove('tab-active'));

      var tabId = this.getAttribute('data-id');
      document.querySelector(".image-column-tab[data-id='" + tabId + "']").classList.add('tab-active');

      document.querySelectorAll('.tab-target').forEach(tabLink => tabLink.classList.remove('tab-active'));
      this.classList.add('tab-active');
    });
  });
});



console.log(456);
const swipslide4 = document.querySelector('.video-box-slider');
if (swipslide4){
var swiper = new Swiper('.video-box-slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  // slideToClickedSlide: true,
  a11y: false,
  shortSwipes: true,
  breakpoints: {
    749: {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
    }
  }
});
}
console.log(123);
// new Swiper('.image_width_text_slider', {
//   loop: false,
//   paginationClickable: true,
//   slidesPerView: 1,
//     navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   },
// });

const swipslide5 = document.querySelector('.image_width_text_slider');
if (swipslide5){
new Swiper('.image_width_text_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: false,
  navigation: {
    nextEl: '.image_width_text_slider .swiper-button-next',
    prevEl: '.image_width_text_slider .swiper-button-prev',
  },
  pagination: {
    el: '.image_width_text_slider .swiper-pagination',
    type: "fraction",
  },
  scrollbar: {
    el: '.image_width_text_slider .swiper-scrollbar',
  },
});
}



// const swipslide6 = document.querySelector('.featured_collection_slider');
// if (swipslide6){
// new Swiper('.featured_collection_slider', {
//   slidesPerView: 'auto',
//   centeredSlides: false,
//   paginationClickable: true,
//   loop: false,
//   slideToClickedSlide: false,
//   navigation: {
//     nextEl: '.featured_collection_slider .swiper-button-next',
//     prevEl: '.featured_collection_slider .swiper-button-prev',
//   },
//   pagination: {
//     el: '.featured_collection_slider .swiper-pagination',
//     type: "fraction",
//   },
//   scrollbar: {
//     el: '.featured_collection_slider .swiper-scrollbar',
//   },
// });
// }


let collectionSwiper = null;

function featuredCollectionSlider() {
  collectionSwiper = new Swiper('.featured_collection_new_slider', {
    slidesPerView: 'auto',
    centeredSlides: false,
    paginationClickable: true,
    loop: false,
    slideToClickedSlide: false,
    navigation: {
      nextEl: '.featured_collection_new_slider .swiper-button-next',
      prevEl: '.featured_collection_new_slider .swiper-button-prev',
    },
  });
}

function destroyCollectionSwiper() {
  if (collectionSwiper !== null && collectionSwiper !== undefined) {
    collectionSwiper.destroy();
    collectionSwiper = null;
  }
}

if (window.innerWidth < 989) {
  featuredCollectionSlider();
} else {
  destroyCollectionSwiper(); // Destroy swiper if initial width > 989
}

window.addEventListener('resize', () => {
  if (window.innerWidth < 989) {
    if (!collectionSwiper) {
      featuredCollectionSlider();
    }
  } else {
    destroyCollectionSwiper();
  }
});


const swipslide7 = document.querySelector('.collection_list_slider');
if (swipslide7){

new Swiper('.collection_list_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: false,
  navigation: {
    nextEl: '.collection_list_slider .swiper-button-next',
    prevEl: '.collection_list_slider .swiper-button-prev',
  },
  pagination: {
    el: '.collection_list_slider .swiper-pagination',
    type: "fraction",
  },
  scrollbar: {
    el: '.collection_list_slider .swiper-scrollbar',
  },
});

}

const swipslide8 = document.querySelector('.reveiw_slider');
if (swipslide8){
new Swiper('.reveiw_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: false,
  navigation: {
    nextEl: '.reveiw_slider .swiper-button-next',
    prevEl: '.reveiw_slider .swiper-button-prev',
  },
  pagination: {
    el: '.reveiw_slider .swiper-pagination',
    type: "fraction",
  },
  scrollbar: {
    el: '.reveiw_slider .swiper-scrollbar',
  },
});
}

const swipslide14 = document.querySelector('.pdp_ingredients_mobile_slider');

if (swipslide14 && window.innerWidth <= 768) {
  new Swiper('.pdp_ingredients_mobile_slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: false,
    loop: false,
    slideToClickedSlide: false,
    navigation: {
      nextEl: '.pdp_ingredients_mobile_slider .swiper-button-next',
      prevEl: '.pdp_ingredients_mobile_slider .swiper-button-prev',
    },
    pagination: {
      el: '.pdp_ingredients_mobile_slider .swiper-pagination',
      type: 'bullets', // ← dots instead of fraction
      clickable: true,
    },
    scrollbar: {
      el: '.pdp_ingredients_mobile_slider .swiper-scrollbar',
    },
  });
}

function initializeSwiper() {
  new Swiper('.related_product_slider', {
    slidesPerView: 'auto',
    centeredSlides: false,
    paginationClickable: true,
    loop: false,
    slideToClickedSlide: false,
    navigation: {
      nextEl: '.related_product_slider .swiper-button-next',
      prevEl: '.related_product_slider .swiper-button-prev',
    },
    pagination: {
      el: '.related_product_slider .swiper-pagination',
      type: "fraction",
    },
    scrollbar: {
      el: '.related_product_slider .swiper-scrollbar',
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeSwiper();

  setTimeout(initializeSwiper, 2000);
});

const swipslide17 = document.querySelector('.doctor-review-slider');
if (swipslide17){
new Swiper('.doctor-review-slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: false,
  navigation: {
    nextEl: '.doctor-review-slider .swiper-button-next',
    prevEl: '.doctor-review-slider .swiper-button-prev',
  },
  pagination: {
    el: '.doctor-review-slider .swiper-pagination',
    type: "fraction",
  },
  scrollbar: {
    el: '.doctor-review-slider .swiper-scrollbar',
  },
});
}


function setHeightVariable() {
  const imageBanners = document.querySelectorAll('.image_banner_style2');
  imageBanners.forEach(imageBanner => {
    const height = imageBanner.offsetHeight;
    imageBanner.style.setProperty('--height', `${height}px`);
  });
}
document.addEventListener("DOMContentLoaded", function () {
  setHeightVariable();
});
window.addEventListener('resize', function () {
  setHeightVariable();
});




// document.addEventListener('DOMContentLoaded', function() {
//     function closeModal() {
//         document.getElementById('newsletter_modal').classList.remove('open');
//     }
//     document.querySelector('.modal-close').addEventListener('click', closeModal);
//     document.querySelector('.modal-no-thanks a').addEventListener('click', closeModal);
//     document.querySelectorAll('.modal-exit').forEach(function(element) {
//         element.addEventListener('click', closeModal);
//     });
// });

// function mainProductPageSlider() {
// console.log("mainGallery");

// const mainGallery = document.querySelector('.gallery-slider').swiper;
// const thumbGallery = document.querySelector('.gallery-thumbs').swiper;
// mainGallery?.destroy();
// thumbGallery?.destroy();

// const mainThumbGallery = document.querySelector('.gallery-thumbs');
// if (document.querySelector('.gallery-thumbs') && document.querySelector('.gallery-thumbs').querySelectorAll("li") > 1) {
//   var sliderThumbnail = new Swiper('.gallery-thumbs', {
//     slidesPerView: 'auto',
//     spaceBetween: 10,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//   });
// }

// const mainImageGallery = document.querySelector('.gallery-slider');
// if (document.querySelector('.gallery-slider') && document.querySelector('.gallery-slider').querySelectorAll("li").length > 1) {
//   var slider = new Swiper('.gallery-slider', {
//     slidesPerView: 1,
//     navigation: {
//       nextEl: '.gallery-slider .swiper-button-next',
//       prevEl: '.gallery-slider .swiper-button-prev',
//     },
//     thumbs: {
//       swiper: sliderThumbnail
//     }
//   });
// }

// var mainGallery = document.querySelector('.gallery-slider')?.swiper;
// var thumbGallery = document.querySelector('.gallery-thumbs')?.swiper;
// mainGallery?.destroy();
// thumbGallery?.destroy();

// var mainThumbGallery = document.querySelector('.gallery-thumbs');
// console.log("mainThumbGallery", mainThumbGallery)
// var mainImageGallery = document.querySelector('.gallery-slider');
// if (mainThumbGallery && mainThumbGallery.querySelectorAll("li") > 1) {
//   console.log("THUMB SLIDER");
//   var sliderThumbnail = new Swiper('.gallery-thumbs', {
//     slidesPerView: 'auto',
//     spaceBetween: 10,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//   });
// }
// if (mainImageGallery && mainImageGallery.querySelectorAll("li").length > 1) {
//   console.log("MAIN SLIDER")
//   var slider = new Swiper('.gallery-slider', {
//     slidesPerView: 1,
//     navigation: {
//       nextEl: '.gallery-slider .swiper-button-next',
//       prevEl: '.gallery-slider .swiper-button-prev',
//     },
//     thumbs: {
//       swiper: sliderThumbnail
//     }
//   });
// }
// }



// const variantSelector = document.querySelector('variant-selects');
// if(variantSelector){  
//   variantSelector.addEventListener('change',()=>{
//     setTimeout(()=>{
//       MainGallery();
//     },1000);
//   })
// }

document.addEventListener('DOMContentLoaded', function () {
  function setCookie(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function closeModal() {
    const newsletterModal = document.getElementById('newsletter_modal');
    if (newsletterModal) newsletterModal.classList.remove('open');
    setCookie('modalClosed', 'true');
  }

  if (getCookie('modalClosed') !== 'true') {
    if (document.querySelector('.modal-close')) { document.querySelector('.modal-close').addEventListener('click', closeModal); }
    if (document.querySelector('.modal-no-thanks a')) { document.querySelector('.modal-no-thanks a').addEventListener('click', closeModal); }
    if (document.querySelectorAll('.modal-exit').length > 0) {
      document.querySelectorAll('.modal-exit').forEach(function (element) {
        element.addEventListener('click', closeModal);
      });
    }
  } else {
    const newsletterModal = document.getElementById('newsletter_modal')
    if (newsletterModal) newsletterModal.classList.remove('open');
  }
});



function updatedivHeight() {
  var announcementBar = document.querySelector('.announcement-bar-section');
  if (announcementBar) {
    var announcementHeight = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
  }

  var pdpaction = document.querySelector('.pdp-card--actions');
  if (pdpaction) {
    var pdpactionHeight = pdpaction.offsetHeight;
    document.documentElement.style.setProperty('--pdpaction-height', pdpactionHeight + 'px');
  }
}

document.addEventListener('DOMContentLoaded', updatedivHeight);
window.addEventListener('resize', updatedivHeight);

const bwpFrameInterval = setInterval(() => {
  const bwpFrame = document.querySelector('#bwpFrame');
  if (bwpFrame && bwpFrame.classList.contains('bwp-widget-loaded')) {
    setTimeout(updatedivHeight, 1000);
    clearInterval(bwpFrameInterval);
  }
}, 500);

// Mouse Over on New featured collection
document.addEventListener('DOMContentLoaded', function () {
  const CollectionMainContainer = document.querySelector('.custom_featured_collection_new');
  if (CollectionMainContainer) {
    const SubContainer = CollectionMainContainer.querySelector('.collection-product-list');
    if (SubContainer) {
      const AllLists = SubContainer.querySelectorAll('li.grid__item');
      if (AllLists.length > 0) {
        const firstList = AllLists[0];
        const lastList = AllLists[AllLists.length - 1];
        MouseEnter(firstList, AllLists, "shift-to-right");
        MouseLeave(firstList, AllLists, "shift-to-right");
        MouseEnter(lastList, AllLists, "shift-to-left");
        MouseLeave(lastList, AllLists, "shift-to-left");
      }
      function MouseEnter(element, ForEachVariable, className) {
        element.addEventListener('mouseenter', () => {
          ForEachVariable.forEach(li => {
            li.classList.add(className);
          })
        })
      }
      function MouseLeave(element, ForEachVariable, className) {
        element.addEventListener('mouseleave', () => {
          ForEachVariable.forEach(li => {
            li.classList.remove(className);
          })
        })
      }
    }
  }
})

document.addEventListener('DOMContentLoaded', function () {
  const videoImages = document.querySelectorAll('.video-box-slider .video-image');

  videoImages.forEach(videoImage => {
    const video = videoImage.querySelector('video');

    if (video) {
      videoImage.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          videoImage.classList.add('playing');
        } else {
          video.pause();
          videoImage.classList.remove('playing');
        }
      });
    }
  });
});



const bundleSubInputs = Array.from(document.querySelectorAll(".bundle-sub__checkbox"));
if (bundleSubInputs.length > 0) {
  bundleSubInputs.forEach((bundleSubInput) => bundleSubInput.addEventListener("change", handleBundleSubInputChange.bind(this), true));
}
function handleBundleSubInputChange(event) {
  const input = event.currentTarget;
  const card = input.closest(".card");
  const cardSellingPlanInput = card.querySelector("[name='selling_plan']");
  card.classList.toggle('free_ship', input.checked);
  const priceElements = card.querySelectorAll(".price-item");
  const compareAtPriceElements = card.querySelectorAll(".price-item--compare_at_price");
  const SavePriceElements = card.querySelectorAll(".money-off");
  if (cardSellingPlanInput) {
    const variantPrice = cardSellingPlanInput.getAttribute("data-variant-price");
    const subPrice = cardSellingPlanInput.getAttribute("data-sub-price");
    const compareAtPrice = cardSellingPlanInput.getAttribute("data-variant-cap");
    if (card.classList.contains("free_ship")) {
      cardSellingPlanInput.removeAttribute("disabled");
      if(subPrice == '' ){
        const savePrice = compareAtPrice - variantPrice;
        priceElements.forEach((priceElement) => priceElement.innerHTML = window.Shopify.formatMoney(variantPrice, window.Shopify.money_format));
        SavePriceElements.forEach((SavePrice) => SavePrice.innerHTML = `Save ${window.Shopify.formatMoney(savePrice, window.Shopify.money_format)}`);
      } else {        
        const savePrice = compareAtPrice - subPrice;
        priceElements.forEach((priceElement) => priceElement.innerHTML = window.Shopify.formatMoney(subPrice, window.Shopify.money_format));
        SavePriceElements.forEach((SavePrice) => SavePrice.innerHTML = `Save ${window.Shopify.formatMoney(savePrice, window.Shopify.money_format)}`);
      }
      compareAtPriceElements.forEach((compareAtPriceElement) => compareAtPriceElement.innerHTML = window.Shopify.formatMoney(compareAtPrice, window.Shopify.money_format));
    } else {
      const savePrice = compareAtPrice - variantPrice;
      cardSellingPlanInput.setAttribute("disabled", true);
      priceElements.forEach((priceElement) => priceElement.innerHTML = window.Shopify.formatMoney(variantPrice, window.Shopify.money_format));
      compareAtPriceElements.forEach((compareAtPriceElement) => compareAtPriceElement.innerHTML = window.Shopify.formatMoney(compareAtPrice, window.Shopify.money_format));
      SavePriceElements.forEach((SavePrice) => SavePrice.innerHTML = `Save ${window.Shopify.formatMoney(savePrice, window.Shopify.money_format)}`);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const skioContainer = document.querySelectorAll('.skio-plan-picker');
  if (skioContainer.length > 0) {
    skioContainer.forEach(skio => {
      if (skio) {
        const groupContainer = skio.querySelectorAll('.skio-group-container--available');
        if (groupContainer.length > 0) {
          groupContainer.forEach(group => {
            if (group) {

              const updateDisplayProperties = () => {
                const closestProductInfo = group.closest('product-info');
                const activegroup = group.classList.contains('skio-group-container--selected');
                if (activegroup) { 
                  const groupInput = group.querySelector('.skio-group-input');

                  if (groupInput && groupInput.hasAttribute('skio-one-time')) {
                    const subscriptionValues = closestProductInfo.querySelectorAll('.product-buy-body .subscription-buy-label');
                    subscriptionValues && subscriptionValues.forEach((subscription) => {
                      subscription.style.display = 'none';
                    });

                    // Hide all label_left and label_right spans
                    const labelSpans = closestProductInfo.querySelectorAll('.product-buy-body .product-buy-label:nth-child(2');
                    labelSpans && labelSpans.forEach((label) => {
                      label.style.display = '';
                    });

                    const unscenetedSubscriptionValues = closestProductInfo.querySelectorAll('.unscented__input-div .quantity_save.quantity_save_subscription');
                    unscenetedSubscriptionValues && unscenetedSubscriptionValues.forEach((subscription) => {
                      subscription.style.display = 'none';
                    });
                    
                    const unscenetedLabelValues = closestProductInfo.querySelectorAll('.unscented__input-div .quantity_save:not(.quantity_save_subscription)');
                    unscenetedLabelValues && unscenetedLabelValues.forEach((label) => {
                      if (label.innerHTML != '') {
                        label.style.display = ''; 
                        
                      } else {
                        label.style.display = 'none';
                      }
                    });


                  } else {
                    const subscriptionValues = closestProductInfo.querySelectorAll('.product-buy-body .subscription-buy-label');
                    subscriptionValues.forEach((subscription) => {
                      subscription.style.display = '';
                    });

                    // Show all label_left and label_right spans
                    const labelSpans = closestProductInfo.querySelectorAll('.product-buy-body .product-buy-label:nth-child(2)');
                    labelSpans.forEach((label) => {
                      label.style.display = 'none';
                    });

                    const unscenetedSubscriptionValues = closestProductInfo.querySelectorAll('.unscented__input-div .quantity_save.quantity_save_subscription');
                    unscenetedSubscriptionValues && unscenetedSubscriptionValues.forEach((subscription) => {
                      subscription.style.display = '';
                    });
                    
                    const unscenetedLabelValues = closestProductInfo.querySelectorAll('.unscented__input-div .quantity_save:not(.quantity_save_subscription)');
                    unscenetedLabelValues && unscenetedLabelValues.forEach((label) => {
                      label.style.display = 'none';
                    });
                  }

                }
              }
              
              updateDisplayProperties();

              group.addEventListener('change', () => {
                updateDisplayProperties();
                const closestProductInfo = group.closest('product-info');
                const skioPrice = group.querySelector('.skio-price');
                if (skioPrice) {
                  const innerSpan = skioPrice.querySelector('span');
                  if (innerSpan) {
                    const spanText = innerSpan.innerText;
                    if (closestProductInfo) {
                      closestProductInfo.querySelector('.product_main_price .price__regular .price-item').innerText = spanText;
                      closestProductInfo.querySelector('.product_main_price .price__sale .price-item').innerText = spanText;
                      closestProductInfo.querySelectorAll(".product-form__buttons .price-item").forEach(el => el.innerText = spanText);

                      const compareAtWrapper = closestProductInfo.querySelector(".price--on-sale.price-item--compare_at_price");
                      if(compareAtWrapper) {
                        const regularPrice = parseFloat(spanText.trim().replace('$', ''));
                        const compareAtPrice = parseFloat(compareAtWrapper.innerText.trim().replace('$', ''));

                        let saveAmount = (compareAtPrice - regularPrice).toFixed(2);
                        const saleTagElements = closestProductInfo.querySelectorAll(".price-item__sale");
                        saleTagElements.forEach((saleTagElement) => {
                          saleTagElement.innerHTML = `Save ${window.Shopify.formatMoney(saveAmount,window.Shopify.money_format)}`;
                        });
                      }
                    }
                  }
                }
              })
            }
          })
        }
      }
    })
  }
})


// document.querySelectorAll('.card__content .checkbox input[type="checkbox"]').forEach(checkbox => {
//   const card = checkbox.closest('.card');
//   if (card && checkbox.checked) {
//     card.classList.add('free_ship');
//   }

//   checkbox.addEventListener('change', function () {
//     if (card) {
//       card.classList.toggle('free_ship');
//     }
//   });
// });




if (document.querySelector(".byob-builder-component .toggle-selection")) {
  const toggleSelection = document.querySelector(".byob-builder-component .toggle-selection");
  const carouselComponent = document.querySelector(".byob-builder-component .byob-cart-items");
  const h4Element = toggleSelection.querySelector("h4");

  toggleSelection.addEventListener("click", function () {
    carouselComponent.style.display = carouselComponent.style.display === "none" ? "block" : "none";
    h4Element.textContent = h4Element.textContent === "Hide Bundle" ? "Show Bundle" : "Hide Bundle";
  });
}


// Tabs
document.addEventListener("DOMContentLoaded", function () {
  // Get all tab head items
  const tabHeadItems = document.querySelectorAll(".tab_head_item");

  if (tabHeadItems.length > 0) {

    // Function to handle tab click
    function handleTabClick(event) {
      const clickedTab = event.target;
      const tabId = clickedTab.getAttribute("data-tab");

      // Remove 'active' class from all tab head items
      tabHeadItems.forEach(item => {
        item.classList.remove("active");
      });

      // Add 'active' class to the clicked tab head item
      clickedTab.classList.add("active");

      // Hide all tab items
      const tabItems = document.querySelectorAll(".tab_item");
      tabItems.forEach(item => {
        if (item.id === tabId) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    }

    // Attach click event listeners to each tab head item
    tabHeadItems.forEach(item => {
      item.addEventListener("click", handleTabClick);
    });

    tabHeadItems[0].click();
  }
});





document.addEventListener("DOMContentLoaded", function () {
  const scentModal = document.querySelector('.scent-modal');
  const productInfo = document.querySelector('.product_gallery_main');

  if (scentModal && productInfo) {
    productInfo.parentElement.insertBefore(scentModal, productInfo.nextSibling);
  }

  const scentPopup = document.querySelector('.scent_popup');

  if (scentPopup) {
    scentPopup.addEventListener('click', function () {
      scentModal.classList.add('open');
    });
  }

  const closeScentModal = document.querySelector('.close_scent-modal');

  if (closeScentModal) {
    closeScentModal.addEventListener('click', function () {
      scentModal.classList.remove('open');
    });
  }
});




document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.subscription-toggle-js').forEach(function(element) {
        element.addEventListener('click', function() {
            var parentPanel = element.closest('.selection-panel');
            if (parentPanel) {
                parentPanel.classList.toggle('open');
            }
        });
    });
});


class ShippingProtectionSwitch extends HTMLElement {
  state = {
    isLoading: false,
    isAdded: false,
    productId: undefined,
    variantId: undefined,
  };

  constructor() {
    super();
    this.checkboxText = this.querySelector(".checkbox-state");
    this.input = this.querySelector("input");
    this.state.productId = +this.getAttribute("data-product-id");
    this.state.variantId = +this.getAttribute("data-variant-id");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    // Save to local storage for persistent storage
    const savedState = localStorage.getItem(`shipping-protection-${this.state.productId}`);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      this.state.isAdded = parsedState.isAdded;
      this.input.checked = this.state.isAdded;
      this.checkboxText.textContent = this.state.isAdded === true ? "ON" : "OFF";

      this.updateCartAttribute('_shipping_protection', this.state.isAdded === true ? "true" : null);
    } else {
      this.input.checked = true;
      this.state.isAdded = true;
      this.checkboxText.textContent = "ON";
      this.updateCartAttribute('_shipping_protection', "true");
      this.saveState();
    }
  }
  connectedCallback() {
    this.input.addEventListener("change", this.handleInput.bind(this));
  }

  handleInput(e) {
    this.state.isAdded = e.target.checked;
    this.checkboxText.textContent = this.state.isAdded ? "ON" : "OFF";
    this.handleChange();
    this.saveState();
  }

  saveState() {
    localStorage.setItem(
      `shipping-protection-${this.state.productId}`,
      JSON.stringify({ isAdded: this.state.isAdded })
    );
  }

  getState() {
    return JSON.parse(localStorage.getItem(`shipping-protection-${this.state.productId}`));
  }

  async updateCartAttribute(attributeName, attributeValue) {
    // If attributeValue is null or an empty string, it will remove the attribute
    const attributes = {};
    attributes[attributeName] = attributeValue;

    setTimeout(() => {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes })
      })
        .then(response => response.json())
        .catch(error => {
          console.error('Error:', error);
        });
    }, 3000);
  }

  async handleChange() {
    document.querySelector("body").classList.add("cart-updating");
    this.classList.add("is-loading");
    const { isAdded } = this.getState();
    if (isAdded) {
      await this.updateCartAttribute('_shipping_protection', null);
    } else {
      await this.updateCartAttribute('_shipping_protection', 'true');
    }
    document.querySelector("body").classList.remove("cart-updating");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  customElements.define("shipping-protection", ShippingProtectionSwitch);
});


// Update SellingPlan metafields Data on Product Page
document.addEventListener('DOMContentLoaded', function () {
  const _this = document.querySelector('.product');
  // console.info("(selling-plan-pdp.js)")

  if (_this) {
    try {
      let count = 0;
      const skioPlanPickerInterval = setInterval(() => {
        count++;
        if (count > 30) {
          clearInterval(skioPlanPickerInterval);
        }

        // if (skioPlanPickerContent.text === '' && skioPlanPickerContent.badge === '' && skioPlanPickerContent.note === '') {
        //   clearInterval(skioPlanPickerInterval);
        //   return;
        // };

        const skioPlanPicker = _this.querySelector('[skio-plan-picker]');

        if (skioPlanPicker) {
          // skioPlanPicker.classList.add('layout-v2');

          const sellingPlanSelects = skioPlanPicker.querySelectorAll('[skio-selling-plans]');

          sellingPlanSelects.forEach((select) => {

            select.querySelectorAll('option').forEach((option) => {
              option.textContent = option.textContent.replace('Delivery every ', '');
            });

            const sellingPlanGroupLabel = select.closest('.skio-group-label');

            if (select.options.length > 1) {
              const selectLabel = document.createElement('div');
              selectLabel.classList.add('skio-group-select-label');
              selectLabel.textContent = 'Delivery Every:';

              select.insertAdjacentElement('beforebegin', selectLabel);
            }

            if (sellingPlanGroupLabel) {
              if (skioPlanPickerContent.badge !== '') {
                const sellingPlanBadge = document.createElement('div');
                sellingPlanBadge.classList.add('skio-group-badge');
                sellingPlanBadge.textContent = skioPlanPickerContent.badge;

                sellingPlanGroupLabel.insertAdjacentElement('afterbegin', sellingPlanBadge);
              }

              if (skioPlanPickerContent.text !== '') {
                const sellingPlanText = document.createElement('div');
                sellingPlanText.classList.add('skio-group-text');
                sellingPlanText.innerHTML = skioPlanPickerContent.text;

                const sellingPlanGroupContent = sellingPlanGroupLabel.querySelector('.skio-group-content');
                if (sellingPlanGroupContent) sellingPlanGroupContent.insertAdjacentElement('beforebegin', sellingPlanText);
              }

              if (skioPlanPickerContent.note !== '') {
                const sellingPlanNote = document.createElement('div');
                sellingPlanNote.classList.add('skio-group-note');
                sellingPlanNote.textContent = skioPlanPickerContent.note;

                sellingPlanGroupLabel.insertAdjacentElement('beforeend', sellingPlanNote);
              }
            }
          });

          clearInterval(skioPlanPickerInterval);
        }
      }, 250);
    } catch (error) {
      console.error('An error occurred while processing the Skio plan picker:', error);
    }
  }
});



// // subscribe_active and one_time_active class add in PACK Start 
document.addEventListener("DOMContentLoaded", function () {
  const scentsWrapper = document.querySelector('.scents_pack_label_wrapper');
  const oneTimeInput = document.querySelector('input[skio-one-time]');
  const subscribeInputs = document.querySelectorAll('input[skio-selling-plan-group]');

  // Function to update class based on current checked input
  function updateActiveClass() {
    if (oneTimeInput && oneTimeInput.checked) {
      scentsWrapper.classList.add('one_time_active');
      scentsWrapper.classList.remove('subscribe_active');
    } else {
      // If any subscribe input is checked
      let subscribeChecked = Array.from(subscribeInputs).some(input => input.checked);
      if (subscribeChecked) {
        scentsWrapper.classList.add('subscribe_active');
        scentsWrapper.classList.remove('one_time_active');
      }
    }
  }

  // Initial check on page load
  if (scentsWrapper) {
    updateActiveClass();
  }

  // Event listeners for click changes
  if (oneTimeInput && scentsWrapper) {
    oneTimeInput.addEventListener('click', function () {
      updateActiveClass();
    });
  }

  if (subscribeInputs.length && scentsWrapper) {
    subscribeInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        updateActiveClass();
      });
    });
  }
});
// // subscribe_active and one_time_active class add in PACK End 



document.addEventListener("DOMContentLoaded", function () {
  const packLabels = document.querySelectorAll(".scents_pack_label_wrapper .pack_label");
  const scentLabel = document.querySelector(".scents_option.form__label");

  function updateScentLabel() {
    const firstPackLabel = packLabels[0]; // 1 pack
    if (firstPackLabel.classList.contains("active")) {
      scentLabel.textContent = "Choose Any Scent:";
    } else {
      scentLabel.textContent = "Choose Any Scents:";
    }
  }

  // On page load
  updateScentLabel();

  // On click
  packLabels.forEach(function (label) {
    label.addEventListener("click", function () {
      packLabels.forEach(l => l.classList.remove("active"));
      this.classList.add("active");
      updateScentLabel();
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {

  document.querySelector('.header .menu-drawer-container .icon-hamburger')
  ?.addEventListener('click', function(){
    document.querySelector('#accessiblyAppWidgetButton').style.display = 'none';
  });

  document.querySelector('.header .menu-drawer-container .icon-close')
  ?.addEventListener('click', function(){
    document.querySelector('#accessiblyAppWidgetButton').style.display = '';
  });

});
